<template>
    <div class="c-article__share-btns">
        <!-- <div id="vue-repost-alt">
            <a href="#0" class="c-btn c-btn--repost" @click="openPanel">
                <img src="/img/logo/dyadey-small.svg" alt="Dyadey Logo">
                <span>Repost</span>
            </a>
            <?php include 'partials/_repost-to-panel-alt.phtml'; ?>
        </div> -->
        <div id="vue-copyLink" class="u-relative">
            <a href="#" id="linkCopy" @click.prevent="copyLink">
                <img src="/img/icons/icon-copy-link-article.svg" alt="Copy Article Link">
            </a>
            <div id="messageArea" class="c-fading-message" :class="{ show : error }" @click="error = false">
                <div>
                    <img src="/img/ui/copy-link.svg" alt="Copy link icon">
                    <h5>{{ message }}</h5>
                </div>
                <p>The Community URL Link has been copied to your Clipboard.</p>
            </div>
        </div>
        <a :href="'mailto:?subject=' + encodeURI(shareSubject) + '&body=' + encodeURI(shareBody)"><img src="/img/icons/icon-email-share-article.svg" alt="Share Article via Email"></a>
        <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(selfUrl)" target="_blank"><img src="/img/icons/icon-facebook-article.svg" alt="Share Article via Facebook"></a>
        <a :href="'https://twitter.com/intent/tweet?url=' + encodeURI(selfUrl) + '&text=' + encodeURI(shareText)" target="_blank"><img src="/img/icons/icon-twitter-article.svg" alt="Share Article via Twitter"></a>
        <a v-if="$simpleStore.isMobile" :href="'https://wa.me/?text=' + encodeURI(selfUrl)" target="_blank"><img src="/img/icons/icon-whatsapp-article.svg" alt="Share Article via Whatsapp"></a>
        <!-- <a href="#0"><img src="/img/icons/icon-facebook-messenger-article.svg" alt="Share Article via Facebook Messenger"></a>
        <a href="#0"><img src="/img/icons/icon-pinterest-article.svg" alt="Share Article via Pinterest"></a>
        <a href="#0"><img src="/img/icons/icon-linkedin-article.svg" alt="Share Article via Linkedin"></a> -->
    </div>
</template>

<script>
export default {
    props: ['title'],
    data() {
        return {
            message: '',
            error: false,
            open: false,
            shareSubject: '<community> article on Dyadey.com',
            shareBody: 'I found this great <community> post on Dyadey.com and I thought you might like to check it out:\n\n' + this.title,
            shareText: 'Read this great <community> post on Dyadey.com',
            selfUrl: window.location.href,
            tweetText: ''
        }
    },
    mounted() {
        let communityName = document.getElementById('article-community-name').innerText;
        this.shareSubject = this.shareSubject.replace('<community>', communityName);
        this.shareBody = this.shareBody.replace('<community>', communityName) + '\n' + window.location.href;
        this.shareText = this.shareText.replace('<community>', communityName);
    },
    methods: {
        copyLink() {
            let text = location.href;
            // Create a hidden textarea
            let textArea = document.createElement('textarea');

            // Styling to ENSURE the box is not visible or flash on screen
            textArea.style.position = 'fixed';
            textArea.style.top = 0;
            textArea.style.left = 0;
            textArea.style.width = '2em';
            textArea.style.height = '2em';
            textArea.style.padding = 0;
            textArea.style.border = 'none';
            textArea.style.outline = 'none';
            textArea.style.boxShadow = 'none';
            textArea.style.background = 'transparent';
            textArea.value = text;

            // Append hidden textarea to body
            document.body.appendChild(textArea);

            // Select the contents of the text field
            textArea.select();
            try {
                // Copies current selection to the clipboard
                let successful = document.execCommand('copy');
                let msg = successful ? 'successful' : 'unsuccessful';

                // Success Message
                this.error = true;
                this.message = 'Link copied!';

                // setTimeout to allow animation
                setTimeout(function() {
                    // Remove show class
                    document.getElementById('messageArea').classList.remove('show');
                }, 5000);
            } catch (err) {
                // Error Message
                this.error = false;
                this.message = 'Link could not be copied!';
            }
            // Remove hidden textarea
            document.body.removeChild(textArea);
        },
        openPanel() {
            this.open = true;
        },
        closePanel() {
            this.open = false;
        }
    }
}
</script>
